import request from '../utils/request'

//是否参加打卡活动
export function getIsJoinApi(params) {
  return request({
    method: 'get',
    url: `/api/wechat/clock/isjoin/${params.studentId}`,
  })
}

//判断是否打卡
export function getIsClockApi(params) {
  return request({
    method: 'get',
    url: '/api/wechat/clock/isin',
    params
  })
}

// 获取打卡记录
export function getClockApi(params) {
  return request({
    method: 'get',
    url: '/api/wechat/clock/log',
    params
  })
}

// 提交打卡
export function confirmClockApi(data) {
  return request({
    method: 'post',
    url: '/api/wechat/clock/in',
    data
  })
}

